module.exports = __webpack_public_path__ + "img/9_12.c197f0df.png";